// extracted by mini-css-extract-plugin
export default {"wrapperContainer":"PageWrapper_wrapperContainer__7aQIR","pagesContainer":"PageWrapper_pagesContainer__tCgED"};